import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Link from '@mui/material/Link';

import { useStore } from '@/dmdrive/store';

import { NoProjectsAlertRoot } from './ProjectsList.styles';

import LoadingSkeleton from './LoadingSkeleton/LoadingSkeleton';
import ProjectBlock from './ProjectBlock/ProjectBlock';

interface ProjectsListProps {
  onCreateNewProject: () => void;
}

function ProjectsList(props: ProjectsListProps) {
  const { onCreateNewProject } = props;
  const { isFetching, projectsList } = useStore('driveStore');

  if (isFetching && projectsList.length === 0) {
    return <LoadingSkeleton />;
  }

  if (!isFetching && projectsList.length === 0) {
    return (
      <NoProjectsAlertRoot color="warning" icon={false}>
        <Typography align="center">
          <span>No project items. You can </span>

          <Link href="#" onClick={onCreateNewProject}>
            create your first project.
          </Link>
        </Typography>
      </NoProjectsAlertRoot>
    );
  }

  return (
    <Grid container spacing={2} mb={4}>
      {projectsList.map((project) => (
        <Grid key={project.id} size={4}>
          <ProjectBlock project={project} />
        </Grid>
      ))}
    </Grid>
  );
}

export default observer(ProjectsList);
